import { AuthenticationMethod } from 'auth/types/authentication-method.type';
import { TokenResponse } from 'auth/types/token-response.type';
import { useConfig } from 'providers/config/ConfigProvider';
import { useEffect } from 'react';

type UseSessionRefreshProps = {
  authApi: AuthenticationMethod;
  token: TokenResponse | undefined;
};

export const useSessionRefresh = ({ authApi, token }: UseSessionRefreshProps) => {
  const env = useConfig();
  useEffect(() => {
    const intervalId = setInterval(() => {
      (async () => {
        await authApi.refreshSessionIfExpired();
      })();
    }, env.auth.refreshIntervalSeconds * 1000);

    return () => clearInterval(intervalId);
  }, [authApi, env.auth.refreshIntervalSeconds, token]);
};
